import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Work", id: "portfolio" },
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Contact", id: "contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 1.4, ease: [0.76, 0, 0.24, 1] }}
      className={`fixed top-0 left-0 right-0 z-[100] transition-colors duration-500 ${
        scrolled ? "bg-[#050505]/80 backdrop-blur-md border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          onClick={() => go("hero")}
          className="flex items-center gap-2 group"
          data-testid="nav-logo"
        >
          <span className="font-anton text-xl tracking-tight text-white">TMB</span>
          <span className="w-2 h-2 bg-[#5cc6ff] group-hover:scale-150 transition-transform" />
          <span className="font-outfit text-xs uppercase tracking-[0.3em] text-white/50 hidden sm:inline">
            Fotografia
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-${l.id}`}
              className="font-outfit text-sm uppercase tracking-[0.15em] text-white/70 hover:text-[#5cc6ff] transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#5cc6ff] group-hover:w-full transition-all duration-300" />
            </button>
          ))}
        </nav>

        <button
          onClick={() => go("contact")}
          data-testid="nav-book-btn"
          className="hidden md:inline-flex items-center font-outfit text-sm font-bold uppercase tracking-[0.15em] bg-[#5cc6ff] text-[#050505] px-6 py-3 hover:bg-white transition-colors"
        >
          Book a Shoot
        </button>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-[#050505] border-t border-white/10"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  onClick={() => go(l.id)}
                  data-testid={`nav-mobile-${l.id}`}
                  className="font-anton text-3xl uppercase text-white text-left"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
